import React, { FC } from 'react';
import { IconProps } from './type';

const Icon: FC<IconProps> = ({ color = 'white', size = '16px' }) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 15 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                x="0.9375"
                y="-0.9375"
                width="11.875"
                height="11.875"
                rx="4.0125"
                transform="matrix(1 0 0 -1 0.681152 12.1921)"
                stroke={color}
                strokeWidth="1.875"
            />
        </svg>
    );
};
export default Icon;
